declare namespace angular.ui {

    //export interface IStateProvider {
    //    dashboardState(name: string,
    //        config: IStateGen<dg.actions.IQueryResultDisplayerStateResolve>): IStateProvider;

    //    detailsState(name: string,
    //        config: IStateGen<dg.actions.IQueryResultDisplayerStateResolve>): IStateProvider;
    //}

}

module dg.actions {



    export interface IQueryResultDisplayerOptions extends IQueryOptions {
      
    }

    export interface IQueryResultDisplayerStateResolve extends angular.ui.IViewStateResolve {
        templateUrl?(...args: any[]): string | ng.IPromise<string>;
        headerUrl?(...args: any[]): string | ng.IPromise<string>;
        queryResult?(...args: any[]): dg.domain.IDomainObject | ng.IPromise<dg.domain.IDomainObject>;
        options?(...args: any[]): IQueryResultDisplayerOptions | ng.IPromise<IQueryResultDisplayerOptions>;
        template?(): string;
    }

    export class QueryResultDisplayerController {

        public bodyStyle = { height: '0px' };
        public bodyHeight: number;
        public queryResult: any;

        private currentStateName: string;

        public constructor(
            private actionService: dg.actions.ActionService,
            private $filter: dgUtils.IFilterService,
            public $scope: ng.IScope,
            private commandExecutedChannelService: dg.actions.CommandExecutedChannelService,
            private $state: ng.ui.IStateService,
            private $element: ng.IAugmentedJQuery,
            private $window: ng.IWindowService,
            private $timeout: ng.ITimeoutService
        ) {
        }

        private destroyCommandExecutedHnadler: () => void;

        $onChanges = () => {
        }

        $onInit = () => {

            angular.element(document).ready(() => {
                this.recalculateBodyHeight();   
                this.recalculateHeights();

                angular.element(this.$window).on('resize', this.resize);
            });

            this.currentStateName = this.$state.current.name;

            this.destroyCommandExecutedHnadler = this.commandExecutedChannelService.onCommandExecuted(this.$scope, c => {
                let deleteCommand = c.domainType.toLowerCase() == "delete";
                this.reload(deleteCommand);
            });
        }


        $onDestroy() {
            angular.element(this.$window).off('resize', this.resize);
            this.destroyCommandExecutedHnadler();
        }

        private resize = () => {
            this.recalculateBodyHeight();
            this.recalculateHeights();
        }

        private recalculateHeights = () => {
            this.bodyStyle.height = this.bodyHeight + 'px';
        }

        private recalculateBodyHeight = () => {
            this.bodyHeight = 5 + dgUtils.UiService.recalculateViewHeight(this.$window.innerHeight);
        }

        reload = (deleteCommand) => {
            //HACK: timout so the state transition will finish 
            //and current state will be the state of the query result displayer

            this.$timeout(() => {
                //Ensure that current state is our state
                if (this.currentStateName == this.$state.current.name) {
                    if (deleteCommand) {
                        this.$window.history.back();
                    } else {
                        this.$state.reload();
                        this.recalculateBodyHeight();
                        this.recalculateHeights();
                    }

                }
            });
        }
    }

    angular.module('dg.actions').component('queryResultDisplayer', {
        bindings: {
            templateUrl: '<',
            headerUrl: '<',
            queryResult: '<',
            options: '<'
        },
        controller: QueryResultDisplayerController,
        templateUrl: '/digmo/src/actions/query-result/query-result-displayer.html'
    });
}